import { render, staticRenderFns } from "./bulkUpdate.vue?vue&type=template&id=27d5445b&scoped=true&"
import script from "./bulkUpdate.vue?vue&type=script&lang=js&"
export * from "./bulkUpdate.vue?vue&type=script&lang=js&"
import style0 from "./bulkUpdate.vue?vue&type=style&index=0&id=27d5445b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5445b",
  null
  
)

export default component.exports